import React from "react";
import ContentLoader from "react-content-loader";
import { Card } from "@ifgengineering/component-library";
import styled from "styled-components";

const Loader = () => (
  <ContentLoader
    speed={2}
    width={876}
    height={280}
    viewBox="0 0 876 280"
    backgroundColor="#f5f5f5"
    foregroundColor="#dbdbdb"
    overflow="hidden"
  >
    <rect x="0" y="0" rx="8" ry="8" width="144" height="144" />
    <rect x="180" y="0" rx="8" ry="8" width="392" height="18" />
    <rect x="0" y="175" rx="8" ry="8" width="286" height="48" />
    <rect x="180" y="45" rx="12" ry="12" width="153" height="25" />
    <rect x="180" y="97" rx="4" ry="4" width="650" height="15" />
    <rect x="180" y="125" rx="4" ry="4" width="650" height="15" />
    <rect x="240" y="232" rx="8" ry="8" width="286" height="48" />
    <rect x="308" y="175" rx="8" ry="8" width="220" height="48" />
    <rect x="0" y="232" rx="8" ry="8" width="220" height="48" />
    <rect x="545" y="232" rx="8" ry="8" width="120" height="48" />
    <rect x="550" y="175" rx="8" ry="8" width="286" height="48" />
    <rect x="685" y="232" rx="8" ry="8" width="120" height="48" />
  </ContentLoader>
);

const DealListLoadersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const DealCardLoaderContainer = styled.div`
  overflow: hidden;
`;

export const DealListLoader = ({ length = 1 }: { length?: number }) => {
  return (
    <DealListLoadersContainer>
      {Array.from({ length }).map((_, index) => (
        <Card padding="24px" key={index}>
          <DealCardLoaderContainer>
            <Loader />
          </DealCardLoaderContainer>
        </Card>
      ))}
    </DealListLoadersContainer>
  );
};
